"use client";

import { Bolt } from "@/components/icons";
import { cn } from "@/lib/utils";
import type { ApplicationMode } from "@/types/listing";

type Props = {
  mode?: ApplicationMode | null;
  className?: string;
};

/**
 * Marks a home as Express — apply straight away, no housing queue.
 *
 * Only the exception is marked. Requiring the queue is the ordinary case for
 * most of the platform, and badging it too would put a tag on nearly every
 * card, which is the same as marking nothing at all.
 *
 * A plain white tag over the photo, the same as the Kampanj tag beside it: an
 * opaque white plate reads on any photo without a loud colour of its own.
 *
 * "Express" is a product name and identical in both languages, so it is written
 * here rather than translated.
 */
export default function ApplicationModeBadge({ mode, className }: Props) {
  if (mode !== "FIRST_COME") {
    return null;
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-white/95 px-2.5 py-1 text-xs font-semibold leading-none text-gray-900 shadow-sm",
        className
      )}
    >
      <Bolt className="h-3 w-3" aria-hidden />
      Express
    </span>
  );
}
